import api from 'Api'
import { SET_MESSAGE } from '../components/utils'

const URL = '/export-log'

const state = {
  exports: []
}

const getters = {
  getExports: state => {
    return state.exports
  }
}

const actions = {
  async loadExports ({ commit }, payload) {
    let response
    try {
      response = await api().get(`${URL}/${payload.organization_id}`)
      response && commit('SET_EXPORTS', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    return response
  },
  async addExport ({ commit }, payload) {
    let response
    try {
      response = await api().post(`${URL}`, payload)
      if (response && response.data.error) {
        SET_MESSAGE({ type: 'error', message: (response.data && response.data.error) || 'Error' })
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    return response.data
  }
}

const mutations = {
  SET_EXPORTS (state, exports) {
    state.exports = exports
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'exportsAudit'
}
